<template>
    <template v-if="!summaryMode">
        <div class="shipping fluid-table-row clearfix">
            <div class="col-md-8 col-sm-8 col-xs-8">
                {{ getInterfaceText('shop_shippingcosts') }} <span id="shippingLabel">- {{ Cart.ShippingName }}</span>
                <p v-show="Cart.ShippingLabel && Cart.ShippingLabel.length > 0" class="shipping-label">({{ Cart.ShippingLabel }})</p>
                <p v-show="Cart.ShippingExtra && Cart.ShippingExtra.length > 0" class="shipping-extra">
                    <a data-toggle="modal" data-target="#preOrderModal" style="cursor:pointer;">
                        <i class="glyphicon glyphicon-new-window" aria-hidden="true"></i> {{ Cart.ShippingExtra }}
                    </a>
                </p>
            </div>
            <div class="col-md-4 col-sm-4 col-xs-4 text-right">
                <span class="shipping-total">{{ Cart.ShippingCosts_FreightAmountToFormat }}</span>
            </div>
        </div>

        <template v-if="Cart.OrderHandlingCodesMerged && Cart.OrderHandlingCodesMerged.length > 0">
            <div class="orderhandling fluid-table-row clearfix"
                 v-for="(fee, feeIdx) in Cart.OrderHandlingCodesMerged"
                 :key="'order-handling-' + feeIdx">
                <div class="col-md-8 col-sm-8 col-xs-8 text-left">
                    {{ fee.Title }}

                    <button v-if="fee.Description && fee.Description.length > 0"
                            data-toggle="tooltip"
                            data-placement="top"
                            data-html="true"
                            :title="fee.Description">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="8" cy="5" r="1" fill="currentColor" />
                            <path d="M7 7H9V10L7 12V7Z" fill="currentColor" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2.86667C10.8351 2.86667 13.1333 5.16494 13.1333 8C13.1333 10.8351 10.8351 13.1333 8 13.1333C5.16494 13.1333 2.86667 10.8351 2.86667 8C2.86667 5.16494 5.16494 2.86667 8 2.86667ZM15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8Z" fill="currentColor" />
                        </svg>
                        <span class="sr-only">{{ fee.Title }}</span>
                    </button>

                </div>
                <div class="col-md-4 col-sm-4 col-xs-4 text-right">
                    <span class="shipping-total">{{ fee.FreightAmountToFormat }}</span>
                </div>
            </div>
        </template>
        <div v-else-if="Cart.ShippingCosts_OrderHandlingAmountToFormat != null" class="shipping fluid-table-row clearfix">
            <div class="col-md-8 col-sm-8 col-xs-8">
                {{ getInterfaceText('shop_orderhandlingcosts') }}
                <button v-if="getInterfaceText('shop_orderhandlingCosts_explanation').length > 0"
                        type="button"
                        data-toggle="modal"
                        data-target="#orderhandlingModal"
                        style="cursor: pointer; color: inherit; border: none; background: none;">
                    <i class="glyphicon glyphicon-question-sign" aria-hidden="true"></i>
                    <span class="sr-only">Open Destination Fee explanation</span>
                </button>
            </div>
            <div class="col-md-4 col-sm-4 col-xs-4 text-right">
                <span class="shipping-total">{{ Cart.ShippingCosts_OrderHandlingAmountToFormat }}</span>
            </div>
        </div>

        <div v-show="Cart.ShippingCosts_ExtraToFormat && Cart.ShippingCosts_ExtraToFormat.length > 0"
             class="shipping fluid-table-row clearfix">
            <div class="col-md-8 col-sm-8 col-xs-8">
                {{ getInterfaceText('shop_shippingcosts_extra') }}
                <button v-if="getInterfaceText('shop_shippingcosts_extra_description').length > 0"
                        type="button"
                        class="btn-link shippingcosts_extraPopover"
                        tabindex="0"
                        data-toggle="popover"
                        data-html="true"
                        data-placement="top"
                        :data-content="getInterfaceText('shop_shippingcosts_extra_description')"
                        style="color: #000; padding: 0;">
                    <i class="glyphicon glyphicon-question-sign" aria-hidden="true"></i>
                    <span class="sr-only">Open Shipping costs extra fee explanation</span>
                </button>
            </div>
            <div class="col-md-4 col-sm-4 col-xs-4 text-right">
                <span class="shipping-total">{{ Cart.ShippingCosts_ExtraToFormat }}</span>
            </div>
        </div>

        <div v-if="ProductPriceExcludedTax" class="tax fluid-table-row clearfix">
            <div class="col-md-6 col-sm-6 col-xs-6">{{ getInterfaceText('shop_tax') }}</div>
            <div class="col-md-6 col-sm-6 col-xs-6 text-right"><span class="cart-tax">{{ Cart.TaxToFormat }}</span></div>
        </div>
        <div class="savings fluid-table-row clearfix" v-show="Cart.TotalSavings > 0">
            <div class="col-md-8 col-sm-8 col-xs-8 text-left">
                {{ getInterfaceText('shop_total_savings') }}
            </div>
            <div class="col-md-4 col-sm-4 col-xs-4 text-right">
                <span class="discountvalue">- <span class="cart-discount">{{ Cart.DiscountToFormat }}</span></span>
            </div>
        </div>
        <div class="total fluid-table-row clearfix" :class="{ 'with-divider': Cart.TotalOrderHandling > 0, 'bottom-divider': !summaryMode  }">
            <div class="col-md-6 col-sm-6 col-xs-6 text-left">
                <span class="cart-total-label">{{ getInterfaceText('shop_total') }}</span>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-6 text-right">
                <span class="cart-total">{{ Cart.TotalIncludingOrderHandlingToFormat }}</span>
                <span v-if="ShowTaxInclusiveTag">
                    <br /><span style="font-size:10px;font-weight:normal;">{{ getInterfaceText('shop_vat_inclusive') }}</span>
                </span>
            </div>
        </div>
    </template>
    <template v-else>
        <div class="subtotal fluid-table-row clearfix" v-show="Cart.TotalSavings > 0 || Cart.TotalOrderHandling > 0">
            <div class="col-md-8 col-sm-8 col-xs-8 text-left">
                {{ getInterfaceText('shop_subtotal') }}
            </div>
            <div class="col-md-4 col-sm-4 col-xs-4 text-right">
                <span>{{ Cart.SubtotalToFormat }}</span>
            </div>
        </div>
        <template v-if="Cart.OrderHandlingCodesMerged && Cart.OrderHandlingCodesMerged.length > 0">
            <div class="orderhandling fluid-table-row clearfix"
                 v-for="(fee, feeIdx) in Cart.OrderHandlingCodesMerged"
                 :key="'order-handling-' + feeIdx">
                <div class="col-md-8 col-sm-8 col-xs-8 text-left">
                    {{ fee.Title }}

                    <button v-if="fee.Description && fee.Description.length > 0"
                            data-toggle="tooltip"
                            data-placement="top"
                            data-html="true"
                            :title="fee.Description">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="8" cy="5" r="1" fill="currentColor" />
                            <path d="M7 7H9V10L7 12V7Z" fill="currentColor" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2.86667C10.8351 2.86667 13.1333 5.16494 13.1333 8C13.1333 10.8351 10.8351 13.1333 8 13.1333C5.16494 13.1333 2.86667 10.8351 2.86667 8C2.86667 5.16494 5.16494 2.86667 8 2.86667ZM15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8Z" fill="currentColor" />
                        </svg>
                        <span class="sr-only">{{ fee.Title }}</span>
                    </button>

                </div>
                <div class="col-md-4 col-sm-4 col-xs-4 text-right">
                    <span class="shipping-total">{{ fee.FreightAmountToFormat }}</span>
                </div>
            </div>
        </template>
        <div class="savings fluid-table-row clearfix" v-show="Cart.TotalSavings > 0">
            <div class="col-md-8 col-sm-8 col-xs-8 text-left">
                {{ getInterfaceText('shop_total_savings') }}
            </div>
            <div class="col-md-4 col-sm-4 col-xs-4 text-right">
                <span class="discountvalue">- <span class="cart-discount">{{ Cart.TotalSavingsToFormat }}</span></span>
            </div>
        </div>
        <div class="total fluid-table-row clearfix" :class="{ 'with-divider': Cart.TotalOrderHandling > 0 }">
            <div class="col-md-6 col-sm-6 col-xs-6 text-left">
                <span class="cart-total-label">{{ getInterfaceText('shop_total') }}</span>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-6 text-right">
                <span class="cart-total">{{Cart.TotalIncludingOrderHandlingToFormat}}</span>               
            </div>
        </div>
        <div v-if="ShowTaxInclusiveTag" style="text-align:right;font-size:10px;font-weight:normal;">
             {{getInterfaceText('shop_vat_inclusive')}}
        </div>
    </template>
</template>

<script>
    import cartMixin from '../mixins/cart-mixin.js';
    import generalMixin from '../mixins/general.js';
    export default {
        name: 'CartTotals-DiscoverMode',
        mixins: [cartMixin, generalMixin],
        props: ['editMode', 'summaryMode'],
        data: function () {
            return {
                ProductPriceExcludedTax: false,
                ShowTaxInclusiveTag: false
            }
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-cart-parameters').dataset.interfacetexts);
            this.ProductPriceExcludedTax = document.getElementById('vue-cart-parameters').dataset.productpriceexcludedtax == 'true';
            this.ShowTaxInclusiveTag = document.getElementById('vue-cart-parameters').dataset.showtaxinclusivetag == 'true';
        }
    }
</script>
